<template>
	<div class="qualityenterprise">
		<div class="index_left_centerpage" v-loading="pageLoading">
			<div class="whitebox right_topbox" style="padding-bottom: 1px;">
				<div class="right_boxtitle">
					<span class="fl right_title">全部内资企业搜索</span>
					<div class="fl search-box nz-search-box">
						<span class="searchtype">全部内资企业库</span>
						<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"
							@keydown="searchenter" />
						<button class="search-btn" @click="searchkwfun">查询</button>
					</div>
				</div>
				<div class="opport-screen-list1">
					<dl class="opport-screen bdbe">
						<dt class="fl">省份地区</dt>
						<dd class="fl">
							<span :class="provinceid == 0 ? 'current a-screen' : 'a-screen'"
								@click="provincechoose(0); userdata.provinceText = '全国地区'">全国地区<em class="num">({{
									countryNum }})</em></span>
							<span v-for="(item, index) in provincedata" :key='index'
								@click="provincechoose(item.areaId, index); userdata.provinceText = item.name"
								:class="item.areaId == provinceid ? 'a-screen current' : 'a-screen'">{{ item.name }}<em
									class="num">({{ item.num }})</em></span>
						</dd>
					</dl>
				</div>
			</div>

			<div class="whitebox" style="min-height: 160px;">
				<div class="table-section">
					<div class="table-header">
						<div class="table-title">
							<i class="el-icon-document-checked"></i>
							<span>企业</span>
							<el-tag size="small" type="info">{{ total }} 条</el-tag>
						</div>
					</div>
				</div>
				<div class="enterprise_list_box" v-show="enterpristlist.length != 0">
					<!-- 全部内资企业 -->
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
						<tr>
							<th>序号</th>
							<th>企业名称</th>
							<th>所属产业</th>
							<th>画像标签</th>
							<th>地区</th>
							<th>企业实力</th>
							<th class="editTh">编辑</th>
						</tr>
						<tr v-for="(list, index) in enterpristlist" :key="list.stockCode">
							<td>{{ (page - 1) * pageSize + index + 1 }}</td>
							<td class="title" @click="routerlinkid('/enterprises', list.stockCode, curindex)">
								{{ list.title }}</td>
							<td class="conpanytags hastag">
								<span class="span-tag" v-for="item in list.notionlist" :key="item.id"
									@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{ item.name
									}}</span>
							</td>
							<td class="conpanytags notiontags">
								<span class="span-tag" v-for="(item, i) in list.taglist" :key="i"
									@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{ item.name
									}}</span>
							</td>
							<td>{{ list.area }}</td>
							<td>{{ list.zs100000 }}</td>
							<td class="collectfont1">
								<span @click="listToggleCollect(list)">{{ list.collectId ==
									0 ? '加入' : '移除' }}<br />目标企业</span>
								<span @click="crmtoggle(list, list.stockCode)">{{ list.crmId == 0 ? '加入' : '移除'
								}}项目管理</span>
							</td>
						</tr>
					</table>
				</div>
				<div class="pagination-wrapper oh w95mg py-3">
					<el-pagination class="fr" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="page" :page-sizes="[20]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total" background />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'enterpriseList',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "全部内资企业", countryNum: 0,//全国城市的企业总数量
			pageLoading: false,
			searchTextArry: [],//搜索词分解后的名词
			searchPlaceholder: '请输入企业名称',
			fenkd: { children: [] },
			curindex: 6, comajaxurl: "",
			enterinarr: [
				{ curindex: 1, type: 9, name: "上市公司", tagnum: 10010, },
				{ curindex: 2, type: 1, name: "龙头企业", tagnum: 10010, },
				{ curindex: 3, type: 2, name: "创新企业", tagnum: 3, },
				{ curindex: 4, type: 3, name: "优质企业", tagnum: 10009 },
			],
			userdata: {},
			searchtext: "",
			kwtextsearch: false,
			kwtextsearchtext: "宁德新能源",
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
			provinceid: 0,
			provincedata: [],
			enterpristlist: [],
			orderField: 0, //排序字段 0 分数 1 时间
			orderType: 0, //排序方式 0 降序 1 升序    
			exportnum: 0, //导出次数
			exportpop: false, //点击导出按钮弹框显示
			allowexport: false, //后台判断是否可以上传
			exportbtn: true, //loading小 等待转圈圈
			confirmtext: '确认导出',
			iframeurl: '', notionstep: 0,
			// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
			dimensionList: [
				{ name: '综合', type: 0 }, { name: '拿地数量', type: 5 }, { name: '拿地面积', type: 6 }, { name: '拿地金额', type: 7 }, { name: '投资项目数量', type: 8 }, { name: '投资项目金额', type: 9 }, { name: '控制企业', type: 10 },],
		}
	},
	beforeCreate() {
		// this.pageLoading = true;
	},
	created() {
		this.userdata = this.getuseriformation();
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		// console.log('sercatype:', this.searchtype);
		var defaultlist = {}, _this = this;
		if (this.$route.query.kw) {
			document.title = this.kwtextsearchtext + '-内资企业库搜索';
			this.kwtextsearchtext = this.$route.query.kw ? this.$route.query.kw : '';
			this.ajaxsearchcompany();

		} else {
			this.$message({
				type: 'error',
				message: '请输入关键词搜索',
			});
		}

	},
	methods: {
		//加入移除项目管理
		crmtoggle(data, enterpiseid) {
			// console.log(data);
			var _this = this;
			if (data.crmId == 0) {
				this.$axios.get(this.$api.crm.enterprise.addtoCRM() + "?stockCode=" + enterpiseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
					console.log("添加到CRM库", res);
					if (res.success) {
						data.crmId = res.data.id;
						_this.$message({
							type: 'success',
							message: '已加入项目管理',
						});
					}
				}).catch(function (error) {
					// 请求失败处理 console.log(error);
				});
			} else {
				console.log('移除', data.crmId)
				$.ajax({
					type: "POST",
					url: this.$api.crm.customer.delete(),
					data: { id: data.crmId },
					headers: { AuthToken: this.userdata.token },
					success: function (res) {
						console.log(res)
						if (res.success) {
							data.crmId = 0;
							_this.$message({
								type: 'success',
								message: '已移除项目管理',
							});
						} else {
							_this.$message({ type: "error", message: res.msg })
						}
					}
				})
			}
		},
		//查询是否在crm项目管理中
		crmSearch(enterpiseIdList) {
			//把企业id转换成字符串
			return new Promise((resolve, reject) => {
				var enterpiseId = enterpiseIdList.join(',');
				this.$axios.get(this.$api.crm.enterprise.isExist2() + "?codeList=" + enterpiseId, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
					if (res.success) {
						let resdata = res.data;
						resolve(resdata);
					}
				})
			})
		},
		//企业列表导出数据 
		enlistExport() {
			if (this.exportbtn) {
				this.exportpop = true;
			}
		},
		exportlistFun() { //下载报告
			var _this = this;
			var ajaxurl = this.$api.cyl.enterprise.export() + '&token=' + this.userdata.token;
			this.confirmtext = "导出中";
			var iframe = document.getElementById("exportIframe");
			iframe.setAttribute("src", ajaxurl);
			_this.exportnum = this.exportnum--;
			setTimeout(() => {
				_this.confirmtext = "导出成功";
				_this.exportpop = false;
				_this.exportbtn = false;
			}, 5000)
			setTimeout(() => {
				_this.exportbtn = true;
				_this.confirmtext = "确认导出";
				console.log('一分钟冷却计时')
			}, 60000)
		},
		//时间/分数升降序
		tablesort(field) {
			if (field == this.orderField) {
				this.orderType = Math.abs(this.orderType - 1);
			} else {
				this.orderField = field;
			}
			this.ajaxsearchcompany();
		},
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			if (this.searchtext.length > 0) {
				this.provinceid = 0;
				this.kwtextsearchtext = this.searchtext;
				this.ajaxsearchcompany(1);
			} else {
				this.$message({
					type: 'error',
					message: '请输入关键词搜索',
				});
			}
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		pageHandler: function (page) {
			this.ajaxsearchcompany(page);
		},
		provincechoose(id) {
			//省份城市选择
			console.log('省份城市选择', id);
			this.provinceid = id;
			this.ajaxsearchcompany();
		},
		ajaxsearchcompany(pages) {
			this.pageLoading = true;
			this.page = pages ? pages : 1;
			$.ajax({
				type: "POST",
				url: this.$api.cyl.search.enterprise(),
				data: { kw: this.kwtextsearchtext, province: this.provinceid, page: this.page },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log('企业列表', res);
					_this.provincedata = res.cityList;
					if (res.success) {
						document.title = _this.kwtextsearchtext + '-内资企业库搜索';
						var dataenterlist = res.list;
						let enterpriseIdList = [];
						for (var i = 0; i < res.list.length; i++) {
							enterpriseIdList.push(dataenterlist[i].stockCode);
							dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode, 'notionsort');
							dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);
						}
						//处理是否在crm系统中
						_this.crmSearch(enterpriseIdList).then(res => {

							// 合并 crmId 到 dataenterlist
							_this.enterpristlist = dataenterlist.map(item => {
								console.log(res[item.stockCode]);
								return {
									...item,
									crmId: res[item.stockCode], // 如果没有匹配到，默认 crmId 为 0
								};
							})
						})
						_this.totalPage = res.totalPage;
						_this.pageSize = res.pageSize;
						_this.total = res.totalRecord;
						_this.haspage = res.list.length == res.pageSize;
						if (_this.provinceid == 0) {
							_this.searchTextArry = res;
							_this.countryNum = res.totalRecord;
						}
						// _this.enterpristlist=dataenterlist; 
						this.pageLoading = false;
					} else {

					}
				}
			})
			// console.log(datas);  
		},
		// 分页
		handleSizeChange(val) {
			this.pageSize = val
			this.getEnterpriseList()
		},

		handleCurrentChange(val) {
			this.page = val
			this.getEnterpriseList(val);
		}
	}
}
</script>

<style></style>
